import { ArrowPathRoundedSquareIcon } from '@heroicons/react/24/outline';
export default function LoadingIcon() {
  return <ArrowPathRoundedSquareIcon className="w-12 h-12 animate-spin primary-color mx-auto" />;
}
